import React, { useEffect, useState } from 'react';
import { useTheme } from '../ThemeContext';
import { legalPageFromPath, performLegalBack } from '../utils/legal';
import { scrollToLocationHash } from '../utils/appScroll';
import LegalPages from './LegalPages';

function pageKey() {
  if (typeof window === 'undefined') return null;
  const page = legalPageFromPath(window.location.pathname);
  return page ? page.key : null;
}

/**
 * Legal routes cover the app instead of replacing it. The dashboard, settings
 * list, and signed-out login stay mounted, so Back can return to them.
 * The overlay is the only scroller. The policy body does not nest a second one.
 * The frame is a native flex child of #root so .app-scroll keeps a bounded height.
 */
export default function LegalPageFrame({ children }) {
  const { colors } = useTheme();
  const [page, setPage] = useState(pageKey);

  useEffect(() => {
    const sync = () => setPage(pageKey());
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('legal-page-open', Boolean(page));
    if (!page) return undefined;
    const overlay = document.querySelector('.legal-overlay');
    if (overlay) overlay.scrollTop = 0;
    scrollToLocationHash();
    return undefined;
  }, [page]);

  return (
    <>
      <div
        className="legal-page-frame"
        aria-hidden={page ? 'true' : undefined}
        style={page ? { pointerEvents: 'none' } : undefined}
      >
        {children}
      </div>
      {page ? (
        <div
          className="legal-overlay"
          style={{ background: colors.background, color: colors.text }}
        >
          <LegalPages page={page} onBack={() => performLegalBack()} />
        </div>
      ) : null}
    </>
  );
}
